import Vue from "vue"
import sysInit from './sysInit'
import store_sv from './store_sv'
import moment from "moment";
import api from '@/api';
import { format } from "silly-datetime";
import redmine from "./redmine";
const questioner_logo = require('@/assets/img/user_logo.png')
import vueUtils from '../../utils/utils.js'

const state = {
  selectedId: '',
  showPhone: false,
  lineList:[],
  currentCallerNum:'',
  buddiesList: [],
  registerStatus: false,
  callList:[],
  waitingList:[],
  inCallList:[],
  CALL_STATUS_END:3,
  CALL_STATUS_WAITING:1,
  CALL_STATUS_INCALL:2,
  LONG_TIME_WAITING:30, // SECONDS
  selectedLine:'',
  redmineIssueId:'',
  piGetList: [],
  onCallInfo: {},
  CALL_START_AUDIO_TIME:3000, // millisecond
  Tnumber: '',
  showStopMonitoringConfirmDialog: false,
  stopMonitoring: false,
  stopMonitoringTrigger: '',
  lineNumber: '',
  tNumber: ''
}
function getTransferNum(item){
  if(item.incomingInviteRequest && item.incomingInviteRequest.message.headers.Tnumber && item.incomingInviteRequest.message.headers.Tnumber.length && item.incomingInviteRequest.message.headers.Tnumber[0].raw) {
    return vueUtils.asteriskHeaderArray2Json(item.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum
  }else{
    return ''
  }
}
function updateCurrentCallerInfo(){
  let userInfo = state.callList.find(item => item.telnum == state.currentCallerNum && !item.refreshCustomerInfo)
  if(userInfo){
    sysInit.state.phone_questioner_name = vueUtils.computeFullName(userInfo.lastname, userInfo.firstname);
    sysInit.state.toUpdateUserNameForRedmineHisFlg = true
    sysInit.state.phone_questioner_logo = userInfo.logo_url && userInfo.logo_url !=''? userInfo.logo_url:questioner_logo
  }
}
function checkIfSupportCall(line, isTransfer = false){
  return line.length > 5 || (line.length == 5 && line[0] ==='9') || isTransfer
}
function toPercent(point) {
  var str = Number(point * 100).toFixed(0)
  str = parseInt(str);
  return str;
}
function setCallListBystatus(){
  for(let oneLine of state.lineList ){
    let existsLine = state.callList.find(item => item.telnum == oneLine.LineNumber)
    if(existsLine){
      existsLine.startTime = oneLine.SipSession.data.callTime
      existsLine.time = oneLine.SipSession.data.callTime ? formatTime(oneLine.SipSession.data.callTime):''
      existsLine.isWaiting =(oneLine.SipSession.data && oneLine.SipSession.data.started) ? false : true
      existsLine.isOnHold = oneLine.SipSession.isOnHold;
    }else{
      let lineObj = {
        is_outbound: oneLine.SipSession.data.calldirection == "inbound" ? '0' : '1',
        telnum: oneLine.LineNumber,
        isWaiting: (oneLine.SipSession.data && oneLine.SipSession.data.started) ? false : true,
        refreshEmpathy: true,
        refreshCustomerInfo:true,
        customer_name:"ゲスト",
        logo_url:null,
        current:false,
        heart_change_distance: null,
        similarity:null,
        startTime :oneLine.SipSession.data.callTime,
        time: oneLine.SipSession.data.callTime ? formatTime(oneLine.SipSession.data.callTime):'',
        firstname:"",
        lastname:'ゲスト',
        address:'',
        email:'',
        Tnumber: getTransferNum(oneLine.SipSession),
        isOnHold: oneLine.SipSession.isOnHold
      }
      state.callList.push(lineObj)
    }
  }
  refreshCallList()
  sortCallList()
  state.waitingList = state.callList.filter(item => item.isWaiting && checkIfSupportCall(item.Tnumber?item.Tnumber:item.telnum) )
  state.inCallList = state.callList.filter(item => !item.isWaiting && checkIfSupportCall(item.Tnumber?item.Tnumber:item.telnum))
}
function sortCallList(){
  if(sysInit.state.phone_WaitingSortByTimeFlg){
    state.callList = _.sortBy( state.callList, function(o) { return o.startTime; }).reverse();
  }else{
    state.callList = _.orderBy(state.callList,['similarity'],['desc']);
  }
}
function formatTime(time){
  let timeArr = time.split(':')
  let minutes = Number(timeArr[0]) > 0 ?  timeArr[0] + '分' :''
  let seconds = timeArr[1] + '秒'
  return minutes + seconds
}
function refreshCallList(){
  for(let i = 0; i < state.callList.length;i++) {
    let oneCall = state.callList[i]
    let exitsLine = state.lineList.find(item => item.LineNumber == oneCall.telnum)
    if(exitsLine){
      if(oneCall.refreshEmpathy && !state.piGetList.includes(oneCall.Tnumber ? oneCall.Tnumber : oneCall.telnum)){
        getEmpathyMatchingInfo(oneCall.Tnumber ? oneCall.Tnumber : oneCall.telnum,refreshEmpathy)
        state.piGetList.push(oneCall.telnum)
      }
      if(oneCall.refreshCustomerInfo || (oneCall.Tnumber && !oneCall.hasInfo)){
        getCustomerInfo(oneCall.Tnumber ? oneCall.Tnumber : oneCall.telnum,refreshCustomerInfo)
        // oneCall.hasInfo = true
        // oneCall.refreshCustomerInfo = false;
      }
    }else{
      state.callList.splice(i,1)
    }
  }
}
function refreshCustomerInfo(obj){
  for(let oneCall of state.callList){
    if (oneCall.telnum == obj.telnum || oneCall.Tnumber == obj.telnum){
      oneCall.customer_name = obj.customer_name
      oneCall.firstname = obj.firstname
      oneCall.lastname = obj.lastname
      oneCall.email = obj.email
      oneCall.address = obj.address
      oneCall.logo_url = obj.logo_url && obj.logo_url != '' ? obj.logo_url : questioner_logo
      oneCall.refreshCustomerInfo = false;
      oneCall.hasInfo = true;
      if(!oneCall.isWaiting){
        updateCurrentCallerInfo()
      }
      break
    }
  }

}
function refreshEmpathy(obj){
  console.log('entering refreshEmpathy',obj)
  for(let oneCall of state.callList){
    if (oneCall.telnum == obj.telnum || oneCall.Tnumber == obj.telnum){
      oneCall.heart_change_distance = obj.heart_change_distance
      oneCall.similarity = obj.similarity
      oneCall.refreshEmpathy = false
      break
    }
  }
}
function getCustomerInfo(telnum,callback){
  console.log('getCustomerInfo.....')
  let customerInfo={
    telnum,
    customer_name:'ゲスト',
    logo_url:null,
    firstname:"",
    lastname:'ゲスト',
    address:'',  
    email:'' 
  }  
  try{
    let params = {
      phonenum :telnum
    }
    let type = telnum.length > 5 || (telnum.length == 5 && telnum.startsWith('9') )? 'external': 'internal'
    // let type = 'external'
    console.log('type...',type)
    api.getUserInfoByType(params,type).then((res)=>{
      if(res.data != 'fail'){
        if(res.data.data[0]){
          let userInfo = res.data.data[0]
          console.log("userInfo",userInfo)

          customerInfo.lastname = userInfo.lastname ? userInfo.lastname : 'ゲスト'
          customerInfo.firstname = userInfo.firstname ? userInfo.firstname : ''
          customerInfo.customer_name = vueUtils.computeFullName(customerInfo.lastname, customerInfo.firstname)
          customerInfo.logo_url = userInfo.logo_url
          customerInfo.address = userInfo.current_address || ''
          customerInfo.email = type == 'external'? (userInfo.mail || '' ):(userInfo.address || '')
        }else{
          customerInfo.customer_name = 'ゲスト'
        }
      }
      callback(customerInfo)
    },(err)=>{
      callback(customerInfo)
      console.log(err);
    })
  }catch(err){
    callback(customerInfo)
    console.log(err);
  }
}
function getEmpathyMatchingInfo(telnum,callback){
  console.log('getEmpathyMatchingInfo.....')
  let temp_params = {
    user_phoneNum:telnum,
    login_email: sysInit.state.login_id,
    token:sysInit.state.empathyMatChingToken,
    modeName: sysInit.state.ws_mode,
    chatStatus:"",
  }
  let temp_heart_change_distance = null;
  let temp_similarity = null;
  try{
    api.getEmpathyMatchingInfo(temp_params).then((res)=>{
        if(res.data != "fail" && res.data.data.empathy50){
          if(res.data.data.empathy50<0.3){
            let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
            temp_heart_change_distance = (1- temp_similarity)*50;
          }else{
            temp_heart_change_distance = (1- res.data.data.empathy50)*50;
          }
          temp_similarity = toPercent(res.data.data.empathy50) + "%";
          console.log("empathyinfo--->",res)
          callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
        }else{
          temp_similarity = '--%';
          callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
          console.log("fail")
        }
        state.piGetList = state.piGetList.filter(d => d !== telnum)
      }),(err)=>{
        callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
        console.log("pi error", err);
      }
    }catch(err){
      callback({telnum:telnum,heart_change_distance:temp_heart_change_distance,similarity:temp_similarity})
      console.log(err);
    }
}

function getLatestAITicketByPhone(phoneNum){
  return new Promise((resolve, reject) => {
    api.getUC1IssueAllText({userId: phoneNum}).then((res)=>{
      return resolve({ data: res.data });
    }).catch(err => {
      return reject({ code: -1, err: err })
    })
  })
}

async function callAnswered(callInfo,callback){
  try{
    let lineNum = getTransferNum(callInfo)? getTransferNum(callInfo):callInfo.data.line
    let userInfo = state.callList.find(item => item.telnum == callInfo.data.line)
    let isOutBound = callInfo.data.calldirection !== "inbound"
    let callStart = moment(callInfo.data.callstart.replace(" UTC", "Z")).utcOffset(0).valueOf();
    let timeBetween = moment().utcOffset(0).valueOf() - callStart;

    // 日
    let days = Math.floor(timeBetween / (24 * 3600 * 1000));
    // 時間
    let hoursRound =  timeBetween % (24 * 3600 * 1000);
    let hours = Math.floor(hoursRound / (3600 * 1000)) + days * 24;
    // 分
    let minutesRound = hoursRound % (3600 * 1000);
    let minutes = Math.floor(minutesRound / (60 * 1000));
    // 秒
    let secondsRound = minutesRound % (60 * 1000);
    let seconds = Math.floor(secondsRound / (1000));
    // マイナスの場合、０としてセット
    let waitedTimeStr = "00:00:00";
    if (hours >= 0 && minutes >= 0 && seconds >= 0){
      waitedTimeStr = [String(hours).padStart(2, '0') , String(minutes).padStart(2, '0'), String(seconds).padStart(2, '0')].join(":");
    }

    let relatedIssueId;
    let conversation_uuid;
    let isTransfered = false
    if(callInfo.incomingInviteRequest
        && callInfo.incomingInviteRequest.message
        && callInfo.incomingInviteRequest.message.headers
      ){
        if(callInfo.incomingInviteRequest.message.headers["Issue-Id"] && callInfo.incomingInviteRequest.message.headers["Issue-Id"][0].raw){ 
          relatedIssueId = callInfo.incomingInviteRequest.message.headers["Issue-Id"][0].raw
        }
        if(callInfo.incomingInviteRequest.message.headers.Tnumber && callInfo.incomingInviteRequest.message.headers.Tnumber.length && callInfo.incomingInviteRequest.message.headers.Tnumber[0].raw){ // 転送前のissueid
          relatedIssueId = vueUtils.asteriskHeaderArray2Json(callInfo.incomingInviteRequest.message.headers.Tnumber[0].raw).relatedIssueId
          isTransfered = true
          console.log('Tnumber relatedIssueId', relatedIssueId);
        }
      conversation_uuid = !isOutBound && callInfo.incomingInviteRequest.message.headers.Uniqueid  ?  callInfo.incomingInviteRequest.message.headers.Uniqueid[0].raw : null
    }

    // TODO: 将来从header中取得，暂定方案，取不到关联票号的时候根据电话号码查询
    if(!relatedIssueId){
      // let latestAITicketByPhoneRes = await getLatestAITicketByPhone(lineNum);
      // relatedIssueId = latestAITicketByPhoneRes.data.data.chatbotIssueId;
      try{
        let latestAITicketByPhoneRes = await getLatestAITicketByPhone(lineNum);
        relatedIssueId = latestAITicketByPhoneRes.data.data.chatbotIssueId;
      }catch{
        console.log('......relatedIssueId error')
      }
    } 
    let params ={
			from: isOutBound ? sysInit.state.tel_num : lineNum,
			to: isOutBound ? lineNum : sysInit.state.tel_num,
			isOutBound: isOutBound,
			firstname: userInfo.firstname,
			lastname: userInfo.lastname,
      answerTime:callInfo.data.startTime,
      waitedTime: waitedTimeStr,
      relatedIssueId: relatedIssueId ? relatedIssueId : "",
      logo_url: userInfo.logo_url,
      agentStartTime:moment.utc(callInfo.data.callstart.replace(" UTC", "")).format(),
      conversation_uuid: conversation_uuid,
      isTransfered:isTransfered
		};
    if(state.Tnumber){
      params.from = state.Tnumber
    }
    console.log('getTransferNum(callInfo)....',params)
    api.callAnswered(params).then((res)=>{
      if(res.data != 'fail'){
        if(res.data.data.issueId){
          // context.commit('sysInit/changeTalkStatus', 'start',{ root: true })
          // context.commit('sysInit/changeWSIssueId', res.data.data.issueId,{ root: true });
          callback(res.data.data.issueId)
        }else{
          console.error('no issue id')
        }
      }
    },(err)=>{
      console.log(err);
    })
  }catch(err){
    console.log(err);
  }
}
function endCall(callInfo,callback){
  try{
    let lineNum = callInfo.data.line
    let isOutBound = callInfo.data.calldirection !== "inbound"
    console.log('callInfo.data.callstart', callInfo.data.callstart, moment.utc(callInfo.data.callstart.replace(" UTC", "")).format())
    let params ={
			from: isOutBound ? sysInit.state.tel_num : lineNum,
			to: isOutBound ? lineNum : sysInit.state.tel_num,
			isOutBound: isOutBound,
      issueId:state.redmineIssueId,
      answerTime:callInfo.data.startTime, // UTC time
      //agentStartTime: new Date(callInfo.data.callstart).toISOString() // UTC time - the call is coming
      agentStartTime:moment.utc(callInfo.data.callstart.replace(" UTC", "")).format()
		}
    if(state.Tnumber) {
      params.from = state.Tnumber
    }
    api.callEnd(params).then((res)=>{
      if(res.data != 'fail'){
        if(res.data.data.record_info){
          // context.commit('sysInit/changeTalkStatus', 'start',{ root: true })
          // context.commit('sysInit/changeWSIssueId', res.data.data.issueId,{ root: true });
          callback(res.data.data.record_info)
        }else{
          console.error('end call error')
        }
      }
    },(err)=>{
      console.log(err);
    })
  }catch(err){
    console.log(err);
  }

}

function getOnCallInfo(telNum, callback){
  console.log(telNum);
  api.getOnCallInfo(telNum).then((res) => {
    console.log(res);
    callback(res.data.userInfo ? res.data.userInfo : {})
  }).catch((err) => {
    console.error('end call error')
  });
}
// function setInCallList ()  {
//   let callArr = state.lineList.filter(oneLine => oneLine.SipSession.data && oneLine.SipSession.data.started)
//   state.inCallList = callArr
//   console.log('inCallList.....',state.inCallList)
// }
// function setWaitingList (){
//   let waitArr = state.lineList.filter (oneLine => !oneLine.SipSession.data || !oneLine.SipSession.data.started)
//   state.waitingList = waitArr
//   console.log('waitingList.....',state.waitingList)
// }
const getters = {
  showPhone: state => state.showPhone,
  buddiesList: state => state.buddiesList
}
const actions = {
  setShowPhone: (context, status) => {
    context.commit('setShowPhone', status)
  },
  terminateTheCall(context,item){
    console.log('entering terminateTheCall',item)
    state.selectedLine = state.selectedLine == item.data.line ? '':state.selectedLine
    // 还没接听过电话，由OP或来电者主动挂断来电电话
    if (state.currentCallerNum == '' && sysInit.state.talkStatus != 'end') {
      // 没有等待接听的电话 or 等待接听的电话被自己或对方挂掉
      if (state.waitingList.length == 0 || (state.waitingList.length == 1 && state.waitingList[0].telnum == item.data.line)) {
        sysInit.state.talkStatus = '';
        context.dispatch('sysInit/changerTurnMicStartTitle', 'NEXMO_ASTERISK_PBX_MODE', { root: true })
      }
    } else if (state.currentCallerNum != item.data.line || !checkIfSupportCall(item.data.line, state.Tnumber)) {
      // 接听过电话，这次挂断的是非当前通话或者当前通话是非转送内线
      // 没有其它已经接通的电话，没有等待接通的电话，并且当前support处于响铃状态。
      if (state.inCallList.length == 1 && state.waitingList.length == 0 && sysInit.state.talkStatus == "ringing") {
        sysInit.state.talkStatus = '';
        context.dispatch('sysInit/changerTurnMicStartTitle', 'NEXMO_ASTERISK_PBX_MODE', { root: true })
      }
    } else {
      // 接听过电话，这次挂断的是当前通话，当前通话是外线或者转送的内线
      context.commit('sysInit/changeTalkStatus', 'end',{ root: true })
      store_sv.state.sv_help_isBlingFlg = false;
      store_sv.state.sv_help_phone_end=true;
      state.currentCallerNum == '';
      localStorage.setItem('callType', '3');
      if(state.redmineIssueId != ''){
        /// the call is answered then end the call
        endCall(item,(endCallRecord)=>{
          state.redmineIssueId = ''
          console.log('endCallRecord........',endCallRecord)
          sysInit.state.piRecordInfoObj.piRecordInfo = endCallRecord
          context.dispatch("sysInit/getPiCallInfo",'',{ root: true });
        })
      }
    }
  },
  receiveCall(context,item){
    console.log('receiveCall....',item)
    if (state.inCallList.length == 0 && sysInit.state.talkStatus != "end") {
      sysInit.state.talkStatus = "ringing"
      context.dispatch(
        "sysInit/changerTurnMicStartTitle", "NEXMO_ASTERISK_PBX_MODE",{ root: true }
      );
      if(item.incomingInviteRequest && item.incomingInviteRequest.message.headers.Tnumber && item.incomingInviteRequest.message.headers.Tnumber.length && item.incomingInviteRequest.message.headers.Tnumber[0].raw) {
        state.Tnumber = vueUtils.asteriskHeaderArray2Json(item.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum
      }
    }
  },
  acceptedTheCall(context,item){
    console.log('acceptedTheCall item.....',item)
    context.commit('setCurrentCallerNum', item.data.line)
    // sysInit.state.currentCustomerPhoneNum = sysInit.state.searchConditionForm.phone_number
    if(checkIfSupportCall(item.data.line, state.Tnumber.trimStart())) {
      context.commit('stt/changeMicStatus', { isMicOn: true, isMicPause: false },{ root: true });
      context.commit('sysInit/changeTalkStatus', 'start',{ root: true })
      // context.commit("sysInit/changeSysConfig", { modeFlag:true },{ root: true });
      context.dispatch("sysInit/changerTurnMicStartTitle",sysInit.state.ws_mode,{ root: true });
      // let sttDelay = (item.data.calldirection == "inbound" && getTransferNum(item).length ==0) ?  true: false
      let sttDelay = false
      context.dispatch("stt/firstSttSupport", {sttDelay},{ root: true });
      localStorage.setItem('callType', '2');
      callAnswered(item,(issueId)=>{
          state.redmineIssueId = issueId
          context.commit('sysInit/changeWSIssueId', issueId,{ root: true });
          updateCurrentCallerInfo()
      })
    }
  },
  updateBuddies: (context, buddies) => {
    if(buddies && buddies.length){
      buddies.sort((a, b) => {
        if(a.LastActivity && b.LastActivity) {
          return moment(a.LastActivity.replace(" UTC", "")).diff(moment(b.LastActivity.replace(" UTC", "")), 'seconds' ) > 0 ? -1 : 1
        }
        if(a.lastActivity && b.lastActivity) {
          return moment(a.lastActivity.replace(" UTC", "")).diff(moment(b.lastActivity.replace(" UTC", "")), 'seconds' ) > 0 ? -1 : 1
        }
      })
      context.commit('updateBuddies', buddies)
    }
  },
  setOnCallInfo: (context, telNum) => {
    console.log('t === = = = == elNum',telNum);
    if(telNum){
      getOnCallInfo(telNum,(info)=>{
        state.onCallInfo = info
      })
    } else {
      state.onCallInfo = {}
    }
    
  }
}
const mutations = {
  setShowPhone: (state, status) =>{
    state.showPhone = status
  },
  updateLineList(state, lineList) {
    state.lineList = lineList;
    if(lineList.length>0){
      // console.log('lineList...',lineList)
      Vue.set(state.lineList, 0, state.lineList[0]);
      setCallListBystatus()
    }else{
      state.inCallList = []
      state.waitingList = []
      state.callList = []
    }
  },
  setCurrentCallerNum: (state, callerNum) =>{
    state.currentCallerNum = callerNum
  },
  updateBuddies: (state, buddies) => {
    state.buddiesList = buddies
  },
  setRegisterStatus:(state, status) => {
    state.registerStatus = status
  },
  setRedmineIssueId:(state, issueId) =>{
    state.redmineIssueId = issueId
  },
  setLongTimeWaiting:(state, time) =>{
    state.LONG_TIME_WAITING = time
  },
  updateCallStartAudioTime:(state, time)=>{
    state.CALL_START_AUDIO_TIME = time
  },
  updateShowStopMonitoringConfirmDialog: (state, stopMonitoringConfirmResult) => {
    state.showStopMonitoringConfirmDialog = stopMonitoringConfirmResult.showStopMonitoringConfirmDialog;
    if (stopMonitoringConfirmResult.stopMonitoring) {
      state.stopMonitoring = stopMonitoringConfirmResult.stopMonitoring;
    }
  },
  updateStopMonitoringTrigger: (state, stopMonitoringTrigger) => {
    state.stopMonitoringTrigger = stopMonitoringTrigger;
  },
  updateLineNumber: (state, lineNumber) => {
    state.lineNumber = lineNumber;
  },
  updateTNumber: (state, tNumber) => {
    state.tNumber = tNumber;
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}